/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    modules: '',
    singlemodule:'',
    freemodules:'',
  },
  mutations: {
    setModulesData (state, {modules}) {
      state.modules = modules
    },
    setSingleModuleData (state, {modules}) {
      state.singlemodule = modules
    },
    setFreeModuleData (state, {modules}) {
      state.freemodules = modules
    },
  reset(state){
    state.modules=''
    state.singlemodule=''
    state.freemodules=''
  }
  },
  actions: {
    setModulesData({commit},data){
      commit('setModulesData', {data})
    },
    
    getAllClasses ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/module')
        .then((response) => {
          var modules = response.data
          commit('setModulesData', {modules})
          resolve(modules)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getClassDetails(id){
      return new Promise(function (resolve, reject) {
        api.getData('admin/module/'+id)
        .then((response) => {
          var modules = response.data
          commit('setModulesData', {modules})
          resolve(modules)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    AddModule ({commit}, ModuleDetails) {
      return new Promise(function (resolve, reject) {
        const config = {
          headers: {
              'content-type': 'multipart/form-data'
          }
        }
        api.postData('admin/module/create', ModuleDetails,config).then(res => {
          commit('setModulesData', res.Data)
          resolve(res.Data)
        }).catch((error) => {
          reject(error)
        })
        .then(() => {
        })
      })
    },
    classEdit({commit}, Data) {
      let ModulesDetails=Data.moduleDetails
      let images=ModulesDetails.gallery
      // var formData=new FormData()

      // formData.append('name',ModulesDetails.name)
      // formData.append('price',ModulesDetails.price)
      // formData.append('location',ModulesDetails.location)
      // formData.append('internal_price',ModulesDetails.internal_price)
      // formData.append('hours',ModulesDetails.hours)
      // formData.append('description',ModulesDetails.description)
      // images.forEach(function(element,index){
      //   formData.append('images'+index,element)
      // })

      return new Promise(function (resolve, reject) {
        api.postData('admin/module/' + Data.adminId, ModulesDetails).then(res => {
          commit('setModulesData', res.Data)
          resolve(res.Data)
        }).catch((error) => {
          reject(error)
        })
        .then(() => {
        })
      })
    },
    getClassById ({ commit }, id) {
      // commit('setLoading', { loading: true })
      if (id) {
        api.getData('admin/module/' + id).then(
              res => {
                const modules = res.data
                commit('setSingleModuleData', { modules })
              },
              err => {
              }
          )
      }
    },
    deleteClassById ({ commit }, id) {
      // commit('setLoading', { loading: true })
      if (id) {
        api.postData('admin/module/delete/' + id).then(
              res => {
                const modules = res.data
                commit('setModulesData', { modules })
              },
              err => {
              }
          )
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Modules.js